// extracted by mini-css-extract-plugin
export default {"imageWrapper":"columns_imageWrapper__VNJRn","image":"columns_image__O2SrI","search":"columns_search__BicXb","deleteWrapper":"columns_deleteWrapper__KKd9S"};